<loading [visible]="loading() || saving()"></loading>

@if(!loading()){
<app-custom-modal customTitle="Gestionar Tipos de IVA" (closeFunction)="closeFormFunction()"
    (acceptFunction)="acceptFormFunction()">

    <form [formGroup]="saveForm" (ngSubmit)="saveEntity()" class="space-y-6">

        <div class="space-y-4">
            <div class="flex justify-between items-center">
                <h3 class="text-md font-bold text-neutral-800">Tipos de IVA</h3>
                <button type="button" (click)="addTaxRow()"
                    class="px-3 py-1 text-xs font-medium text-white bg-purple-600 rounded-lg hover:bg-purple-700 transition-colors">
                    + Añadir concepto
                </button>
            </div>

            <div formArrayName="tax_config" class="space-y-3">
                @for (item of taxItems.controls; track item) {
                <div [formGroupName]="$index" class="grid grid-cols-12 gap-3 items-end animate-fade-in">
                    <div class="col-span-10">
                        <label class="block mb-1 text-xs font-medium text-neutral-500">IVA {{ $index + 1 }}</label>
                        <input type="text" inputmode="decimal" decimalInput formControlName="quotient"
                            class="w-full px-3 py-2 text-sm border border-purple-100 rounded-lg focus:ring-2 focus:ring-purple-300"
                            placeholder="Ej: 21">
                    </div>

                    <div class="col-span-2 text-right">
                        <button type="button" (click)="removeTaxRow($index)"
                            class="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                        </button>
                    </div>
                </div>
                } @empty {
                <div class="text-center py-6 border-2 border-dashed border-gray-100 rounded-xl text-gray-400 text-sm">
                    No hay conceptos definidos. Haz clic en "Añadir concepto".
                </div>
                }
            </div>
        </div>
    </form>
</app-custom-modal>
}